const ADD_GPX_TO_PARTICIPANT = "ADD_GPX_TO_PARTICIPANT";
const REMOVE_GPX_FROM_PARTICIPANT = "REMOVE_GPX_FROM_PARTICIPANT";
const SET_PARTICIPANTS_TO_PURCHASE = "SET_PARTICIPANTS_TO_PURCHASE";
const HIDE_PRICE_NOTIFICATION = "HIDE_PRICE_NOTIFICATION";
const SET_RELOAD_RESULTS = "SET_RELOAD_RESULTS";

export { ADD_GPX_TO_PARTICIPANT, REMOVE_GPX_FROM_PARTICIPANT, SET_PARTICIPANTS_TO_PURCHASE, HIDE_PRICE_NOTIFICATION, SET_RELOAD_RESULTS };
